<template>
    <section>
      <el-dialog
        title="编辑"
        :visible.sync="editFormVisible"
        v-model="editFormVisible"
        :close-on-click-modal="false"
        :before-close="closetc"
      >
        <el-form
          :model="editForm"
          label-width="120px"
          :rules="editFormRules"
          ref="editForm"
        >
        <el-form-item label="名称" prop="Name">
            <el-input v-model="editForm.Name" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closetc">关闭</el-button>
          <el-button
            type="primary"
            @click.native="editSubmit"
            :loading="editLoading"
            >提交</el-button
          >
        </div>
      </el-dialog>
    </section>
  </template>
  
  <script>
  import { editMachinesGroup,BaseApiUrl } from "../../api/api";
  export default {
    props: {
        editForm:{}
    },
    data() {
      return {
        token: {
          Authorization: "Bearer ",
        },
        fileAction: BaseApiUrl + "/images/Upload/PicOne",
        editFormVisible:true,
        editLoading: false,
        editFormRules: {
            Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        },
      };
    },
    methods: {
        closetc(index) { 
            this.$parent.closetc(); //将值传给父组件 
        },
      //修改
      editSubmit: function () {
        let _this = this;
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm("确认提交吗？", "提示", {}).then(() => {
              this.editLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.editForm);
              var user = JSON.parse(window.localStorage.user);
              if (user && user.uID > 0) {
                // para.CreateId = user.uID;
                // para.CreateBy = user.uRealName;
              } else {
                this.$message({
                  message: "用户信息为空，先登录",
                  type: "error",
                });
                _this.$router.replace(
                  _this.$route.query.redirect ? _this.$route.query.redirect : "/"
                );
              }
             
              editMachinesGroup(para).then((res) => {
                this.editLoading = false;
                if (res.data.success) {
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  }); 
                  this.$parent.closetc(1);
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
              
            });
          }
        });
      },
    },
    mounted() {  
        let tokenStr = window.localStorage.Token;
        this.token = {
            Authorization: "Bearer " + tokenStr,
        };
       
    },
  };
  </script> 